import { storeStructure } from '../store/reducers';
import tableVod from './tableVoD';

export default {
  title: 'Video On Demand',
  attributeName: storeStructure.VoD,
  getURL: 'vod',
  createURL: '',
  updateURL: 'vodStatus',
  removeURL: 'vod',
  removeReconfirmMessage:'Are you sure you want to delete this VOD and all associated media listed below?',
  removeReconfirmURL:'listmediafromvod',
  sessionParams: [],
  noArea: true,
  tableConfig: tableVod,
  sessionWebsocketParams: [],
  websocketEventChanel: 'vod',
  websocketItem: 'vod',
  autoUpdate: true,
  // websocketNavigation:'users_navigation',

};
